<template>
    <div>
        <template v-if="crud_income_tax_slabs === true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit IncomeTax Slab </h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="editIncomeTaxSlabData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Minimum Income </label>
                            <input v-model="form.min_income" type="text" name="min_income" class="form-control" :class="{ 'is-invalid': form.errors.has('min_income') }">
                            <has-error :form="form" field="min_income"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Maximum Income </label>
                            <input v-model="form.max_income" type="text" name="max_income" class="form-control" :class="{ 'is-invalid': form.errors.has('max_income') }">
                            <has-error :form="form" field="max_income"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fixed Tax </label>
                            <input v-model="form.fixed_tax" type="text" name="fixed_tax" class="form-control" :class="{ 'is-invalid': form.errors.has('fixed_tax') }">
                            <has-error :form="form" field="fixed_tax"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Amount Exceeding </label>
                            <input v-model="form.amount_exceeding" type="text" name="amount_exceeding" class="form-control" :class="{ 'is-invalid': form.errors.has('amount_exceeding') }">
                            <has-error :form="form" field="amount_exceeding"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Percentage On Amount Exeeding </label>
                            <input v-model="form.percentage_amount_exceeding" type="text" name="percentage_amount_exceeding" class="form-control" :class="{ 'is-invalid': form.errors.has('percentage_amount_exceeding') }">
                            <has-error :form="form" field="percentage_amount_exceeding"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/incomeTaxSlabs" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_income_tax_slabs === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_income_tax_slabs === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    min_income : '',
                    max_income : '',
                    fixed_tax : '',
                    amount_exceeding : '',
                    percentage_amount_exceeding : '',
                }),
                crud_income_tax_slabs: null
            };
        },
        methods: {
            editIncomeTaxSlabData() {
                this.$Progress.start();
                this.form.put('/api/updateIncomeTaxSlab')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Income tax slab updated successfully'
                        });
                        this.$router.push('/incomeTaxSlabs');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getEditIncomeTaxSlabData(){
                axios.get('/api/editIncomeTaxSlab/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.record.id;
                        this.form.min_income = res.data.record.min_income;
                        this.form.max_income = res.data.record.max_income;
                        this.form.fixed_tax = res.data.record.fixed_tax;
                        this.form.amount_exceeding = res.data.record.amount_exceeding;
                        this.form.percentage_amount_exceeding = res.data.record.percentage_amount_exceeding;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_income_tax_slabs').then(result => {
                this.crud_income_tax_slabs = result.crud_income_tax_slabs;
            }).then(result => {
                if(this.crud_income_tax_slabs == true){
					this.getEditIncomeTaxSlabData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
